const skillsFrontend = [
    {
        id: "wdc001",
        title: "HTML"
    },
    {
        id: "wdc002",
        title: "CSS"
    },
    {
        id: "wdc003",
        title: "Javascript"
    },
    {
        id: "wdc004",
        title: "React-Bootstrap"
    },
    {
        id: "wdc005",
        title: "React JS"
    },
    {
        id: "wdc006",
        title: "Tailwind CSS"
    },
    {
        id: "wdc007",
        title: "Materialize UI"
    },
    {
        id: "wdc008",
        title: "MDBootstrap"
    },
    {
        id: "wdc009",
        title: "Bootsrtrap"
    },
    {
        id: "wdc012",
        title: "Adobe DreamWeaver"
    },
    {
        id: "wdc013",
        title: "Next JS"
    },
]

export default skillsFrontend;
